import {
  TableContainer,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Table,
  Image,
  Text,
} from '@chakra-ui/react'
import moment from 'moment'
import { DiagnosticImageProcessEnum } from '../../../types/diagnostic-image'
import ProcessingMsg from '../../_shared/ProcessingMsg'
import { AnalysisMalariaReport } from '../../../models/analysis-malaria-report'
import { useTranslation } from 'react-i18next'

const ReportTable = ({
  analysisMalariaReport,
}: {
  analysisMalariaReport: AnalysisMalariaReport
}) => {
  const { t } = useTranslation()

  return (
    <TableContainer mt={4}>
      <Table>
        <TableCaption>
          {t('ai.malaria.report.tableCaptionMsg', {
            totalAnalyzedCells: analysisMalariaReport.totalAnalyzedCells,
            totalAnalysisImagesCount:
              analysisMalariaReport.totalAnalysisImagesCount,
          })}
        </TableCaption>
        <Thead>
          <Tr>
            <Th>{t('shared.common.createdAt')}</Th>
            <Th>{t('shared.common.image')}</Th>
            <Th>{t('shared.common.status')}</Th>
            <Th isNumeric>{t('ai.malaria.report.infectedCount')}</Th>
            <Th isNumeric>{t('ai.malaria.report.uninfectedCount')}</Th>
            <Th isNumeric>{t('ai.malaria.report.estimatedParasitemia')} (%)</Th>
          </Tr>
        </Thead>
        <Tbody color={'brand.lightGrayText'}>
          {analysisMalariaReport.diagnosticImages.map((imageWithAnalysis) => (
            <Tr key={imageWithAnalysis.id}>
              <Td>
                {moment(imageWithAnalysis.analysis?.createdAt).format(
                  'DD.MM.YY HH:mm'
                )}
              </Td>
              <Td>
                <Image
                  src={imageWithAnalysis.mediaUrl}
                  alt="Image"
                  boxSize="32px"
                  objectFit="cover"
                  borderRadius={8}
                />
              </Td>
              <Td>
                {imageWithAnalysis.process ===
                DiagnosticImageProcessEnum.InProgress ? (
                  <ProcessingMsg />
                ) : imageWithAnalysis.process ===
                  DiagnosticImageProcessEnum.Failed ? (
                  <Text color="red.400" fontSize="sm" fontWeight="bold">
                    {imageWithAnalysis.process.toUpperCase()}
                  </Text>
                ) : (
                  <Text>{imageWithAnalysis.process.toUpperCase()}</Text>
                )}
              </Td>
              <Td isNumeric>
                <Text>{imageWithAnalysis.analysis?.infectedRbcCount}</Text>
              </Td>
              <Td isNumeric>
                <Text>{imageWithAnalysis.analysis?.uninfectedRbcCount}</Text>
              </Td>
              <Td isNumeric>
                {imageWithAnalysis.analysis?.estimatedParasitemiaPercent
                  ? `${Number(
                      imageWithAnalysis.analysis.estimatedParasitemiaPercent
                    ).toFixed(2)}%`
                  : '-'}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  )
}

export default ReportTable
